import type { LifeEvent } from '../../types/onelife.ts';

export const CHILDHOOD_EVENTS: LifeEvent[] = [
  {
    "id": "ch_01_birth_health",
    "stageKey": "childhood",
    "age": 1,
    "titleVi": "Khúc Hát Ru Đầu Đời",
    "descriptionVi": "Bạn chào đời trong niềm hân hoan của gia đình. Tiếng khóc đầu đời vang lên mạnh mẽ.",
    "category": "family",
    "choices": [
      {
        "id": "ch_01_a",
        "textVi": "Ngoan ngoãn bú mẹ, ngủ sâu giấc",
        "outcomeTextVi": "Bạn trộm vía mau ăn chóng lớn, mẹ có nhiều thời gian nghỉ ngơi.",
        "healthDelta": 10,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "ch_01_b",
        "textVi": "Quấy khóc dạ đề suốt tháng đầu",
        "outcomeTextVi": "Cả nhà thay phiên thức trắng dỗ dành, tình mẫu tử càng thêm khăng khít.",
        "healthDelta": -5,
        "happinessDelta": -5,
        "wealthDelta": -5,
        "intellectDelta": 0,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ch_02_baptism",
    "stageKey": "childhood",
    "age": 1,
    "titleVi": "Bí Tích Rửa Tội Đầu Đời",
    "descriptionVi": "Cha mẹ đưa bạn đến nhà thờ giáo xứ cử hành Bí Tích Rửa Tội gia nhập đoàn chiên Chúa.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ch_02_a",
        "textVi": "Được cha mẹ và cha mẹ đỡ đầu sốt sắng dâng lên Thiên Chúa",
        "outcomeTextVi": "Bạn lãnh nhận ơn thánh hóa của Bí Tích Rửa Tội, nhận Thánh Bổn Mạng che chở suốt đời.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15,
        "addSacrament": "Bí Tích Rửa Tội",
        "setReligion": "catholic",
        "addVirtue": "Được tái sinh trong Bí Tích Rửa Tội và sự bao bọc của gia đình đạo đức"
      },
      {
        "id": "ch_02_b",
        "textVi": "Gia đình mở tiệc trà nhỏ mừng em bé có tên thánh",
        "outcomeTextVi": "Bà con chòm xóm đến chung vui, cầu chúc bạn một đời bình an, thánh thiện.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 20,
        "addSacrament": "Bí Tích Rửa Tội",
        "setReligion": "catholic"
      }
    ]
  },
  {
    "id": "ch_03_first_steps",
    "stageKey": "childhood",
    "age": 1,
    "titleVi": "Những Bước Chân Chập Chững",
    "descriptionVi": "Tròn một tuổi, bạn buông tay vịn bàn và tự bước đi những bước đầu tiên.",
    "category": "health",
    "choices": [
      {
        "id": "ch_03_a",
        "textVi": "Dũng cảm sải bước lao vào vòng tay cha mẹ",
        "outcomeTextVi": "Cả nhà vỗ tay reo hò, bạn tự tin chạy nhảy khắp nhà.",
        "healthDelta": 10,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "ch_03_b",
        "textVi": "Vấp ngã u trán nhưng tự mình bò dậy không khóc",
        "outcomeTextVi": "Bạn sớm bộc lộ đức tính kiên cường, dẻo dai từ thuở bé.",
        "healthDelta": 5,
        "happinessDelta": 5,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 5,
        "unlockAchievement": "Tự Lập Từ Bé"
      }
    ]
  },
  {
    "id": "ch_04_fever",
    "stageKey": "childhood",
    "age": 2,
    "titleVi": "Cơn Sốt Mọc Răng",
    "descriptionVi": "Những chiếc răng sữa nhú lên khiến bạn sốt cao, bỏ ăn quấy khóc.",
    "category": "health",
    "choices": [
      {
        "id": "ch_04_a",
        "textVi": "Được cha mẹ chườm ấm và cho uống thuốc hạ sốt kịp thời",
        "outcomeTextVi": "Cơn sốt dứt điểm sau hai ngày, nụ cười rạng rỡ trở lại với bạn.",
        "healthDelta": 10,
        "happinessDelta": 5,
        "wealthDelta": -5,
        "intellectDelta": 0,
        "relationsDelta": 10
      },
      {
        "id": "ch_04_b",
        "textVi": "Bà ngoại dùng lá diếp cá giã nhuyễn hạ nhiệt dân gian",
        "outcomeTextVi": "Bạn nhanh chóng dịu mát, hệ miễn dịch thích nghi tốt.",
        "healthDelta": 5,
        "happinessDelta": 5,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ch_05_speech",
    "stageKey": "childhood",
    "age": 2,
    "titleVi": "Tiếng Gọi Đầu Tiên",
    "descriptionVi": "Bạn bắt đầu bập bẹ những âm tiết đầu đời khiến mọi người ngóng chờ.",
    "category": "education",
    "choices": [
      {
        "id": "ch_05_a",
        "textVi": "Cất tiếng gọi rõ ràng \"Ba ơi! Mẹ ơi!\"",
        "outcomeTextVi": "Mẹ rưng rưng xúc động, cha bế bổng bạn lên tận mây xanh.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      },
      {
        "id": "ch_05_b",
        "textVi": "Bắt chước tiếng các con vật trong tranh vẽ",
        "outcomeTextVi": "Khả năng quan sát và ngôn ngữ của bạn phát triển vượt bậc.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ch_06_sibling",
    "stageKey": "childhood",
    "age": 3,
    "titleVi": "Có Thêm Em Nhỏ",
    "descriptionVi": "Mẹ sinh thêm một em bé. Ngôi nhà rộn rã tiếng cười nhưng bạn phải chia sẻ sự chú ý.",
    "category": "family",
    "choices": [
      {
        "id": "ch_06_a",
        "textVi": "Hôn lên trán em và nhường đồ chơi cho em",
        "outcomeTextVi": "Bạn trở thành anh/chị gương mẫu, được cha mẹ hết lòng tin yêu.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": -10,
        "intellectDelta": 5,
        "relationsDelta": 20
      },
      {
        "id": "ch_06_b",
        "textVi": "Hơi hờn dỗi đòi mẹ bế nhiều hơn",
        "outcomeTextVi": "Cha âu yếm giảng giải, bạn dần quen và yêu thương em.",
        "healthDelta": 0,
        "happinessDelta": 5,
        "wealthDelta": -10,
        "intellectDelta": 0,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ch_07_kindergarten",
    "stageKey": "childhood",
    "age": 3,
    "titleVi": "Buổi Đầu Đến Lớp Mầm Non",
    "descriptionVi": "Cánh cổng trường mầm non mở ra, một thế giới bạn bè đầy lạ lẫm.",
    "category": "education",
    "choices": [
      {
        "id": "ch_07_a",
        "textVi": "Chủ động cầm tay bạn mới và chia sẻ bánh kẹo",
        "outcomeTextVi": "Bạn nhanh chóng trở thành thủ lĩnh nhí của nhóm.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      },
      {
        "id": "ch_07_b",
        "textVi": "Say sưa ghép tranh xếp hình một góc yên tĩnh",
        "outcomeTextVi": "Cô giáo nhận xét bạn có tư duy không gian và sự tập trung đáng nể.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ch_08_pet",
    "stageKey": "childhood",
    "age": 4,
    "titleVi": "Chú Cún Con Trung Thành",
    "descriptionVi": "Gia đình đem về một chú cún nhỏ xíu lông vàng mượt mà.",
    "category": "family",
    "choices": [
      {
        "id": "ch_08_a",
        "textVi": "Hằng ngày cho cún ăn và chơi trò đuổi bắt",
        "outcomeTextVi": "Tình yêu loài vật hình thành lòng trắc ẩn sâu sắc trong tâm hồn bạn.",
        "healthDelta": 10,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "ch_08_b",
        "textVi": "Sợ hãi đứng từ xa quan sát",
        "outcomeTextVi": "Bạn cẩn trọng hơn trong các tình huống mới lạ.",
        "healthDelta": 0,
        "happinessDelta": 0,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 0
      }
    ]
  },
  {
    "id": "ch_09_nature",
    "stageKey": "childhood",
    "age": 4,
    "titleVi": "Chuyến Dã Ngoại Đồng Quê",
    "descriptionVi": "Cuối tuần, cả nhà về quê hít thở không khí trong lành giữa cánh đồng lúa chín.",
    "category": "family",
    "choices": [
      {
        "id": "ch_09_a",
        "textVi": "Chạy tung tăng bắt chuồn chuồn và thả diều giấy",
        "outcomeTextVi": "Ký ức tuổi thơ trong trẻo giúp bạn tràn đầy sinh lực và khỏe khoắn.",
        "healthDelta": 15,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15
      },
      {
        "id": "ch_09_b",
        "textVi": "Ngồi nghe ông bà kể chuyện cổ tích xưa",
        "outcomeTextVi": "Vốn từ vựng và tình yêu văn hóa dân gian nhen nhóm trong bạn.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ch_10_pray_with_parents",
    "stageKey": "childhood",
    "age": 4,
    "titleVi": "Kinh Tối Bên Bàn Thờ Gia Đình",
    "descriptionVi": "Mỗi tối trước khi đi ngủ, gia đình thắp nến quỳ đọc kinh tạ ơn Thiên Chúa.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ch_10_a",
        "textVi": "Chắp tay ngay ngắn đọc theo lời kinh Kính Mừng",
        "outcomeTextVi": "Tâm hồn bạn được ướp hương bình an thánh thiện từ tuổi ấu thơ.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "addVirtue": "Thói quen cầu nguyện sớm tối vun trồng hạt giống đức tin"
      },
      {
        "id": "ch_10_b",
        "textVi": "Ngắm nhìn tượng Đức Mẹ hiền từ và cầu cho cha mẹ khỏe mạnh",
        "outcomeTextVi": "Đức hiếu thảo hòa quyện cùng niềm tin cậy mến đơn sơ.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ch_11_coloring",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Hộp Sáp Màu Thần Kỳ",
    "descriptionVi": "Món quà sinh nhật 5 tuổi là một hộp màu sáp 24 màu rực rỡ.",
    "category": "education",
    "choices": [
      {
        "id": "ch_11_a",
        "textVi": "Vẽ ước mơ bay vào vũ trụ và ngôi nhà hạnh phúc",
        "outcomeTextVi": "Bức tranh được dán trang trọng ở phòng khách, bạn rất tự hào.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 10
      },
      {
        "id": "ch_11_b",
        "textVi": "Vẽ nguệch ngoạc lên tường phòng ngủ",
        "outcomeTextVi": "Bị mắng nhẹ nhưng cha mẹ nhận ra sự phóng khoáng tự do của bạn.",
        "healthDelta": 0,
        "happinessDelta": 5,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ch_12_swimming",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Học Bơi Mùa Hè",
    "descriptionVi": "Cha dẫn bạn ra hồ bơi tập làm quen với làn nước mát.",
    "category": "health",
    "choices": [
      {
        "id": "ch_12_a",
        "textVi": "Can đảm úp mặt thở nước và đập chân nổi bồng bềnh",
        "outcomeTextVi": "Bạn biết bơi ếch cơ bản, lồng ngực nở nang, sức khỏe cải thiện rõ rệt.",
        "healthDelta": 20,
        "happinessDelta": 15,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 10
      },
      {
        "id": "ch_12_b",
        "textVi": "Sợ sặc nước nên chỉ ngồi nghịch nước mép bờ",
        "outcomeTextVi": "Bạn an toàn nhưng cần thêm thời gian để vượt qua nỗi sợ.",
        "healthDelta": 5,
        "happinessDelta": 5,
        "wealthDelta": 0,
        "intellectDelta": 0,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ch_13_sharing_food",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Chiếc Bánh Ngọt Chia Đôi",
    "descriptionVi": "Bạn có một chiếc bánh thơm phức, gặp bạn hàng xóm nhà nghèo đang đói bụng.",
    "category": "society",
    "choices": [
      {
        "id": "ch_13_a",
        "textVi": "Bẻ đôi chiếc bánh chia cho bạn cùng ăn ngon lành",
        "outcomeTextVi": "Bạn có thêm người bạn tri kỷ, hạt mầm sẻ chia nở hoa trong lòng.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 25,
        "addVirtue": "Tấm lòng nhân ái biết nhường cơm sẻ áo từ thuở nhỏ"
      },
      {
        "id": "ch_13_b",
        "textVi": "Ăn hết một mình vì chiếc bánh quá ngon",
        "outcomeTextVi": "Bạn no bụng nhưng cảm thấy thoáng chút áy náy khi nhìn ánh mắt bạn.",
        "healthDelta": 5,
        "happinessDelta": 0,
        "wealthDelta": 0,
        "intellectDelta": 0,
        "relationsDelta": -5
      }
    ]
  },
  {
    "id": "ch_14_alphabet",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Làm Quen Với Bảng Chữ Cái",
    "descriptionVi": "Chuẩn bị vào lớp 1, mẹ dạy bạn đánh vần từng chữ cái đầu tiên.",
    "category": "education",
    "choices": [
      {
        "id": "ch_14_a",
        "textVi": "Chăm chú ghép vần và đọc được tên người thân",
        "outcomeTextVi": "Bạn vào lớp 1 với tư thế tự tin, tiếp thu bài vở nhanh chóng.",
        "healthDelta": 0,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 10
      },
      {
        "id": "ch_14_b",
        "textVi": "Mải chơi đồ chơi, học trước quên sau",
        "outcomeTextVi": "Tuổi thơ hồn nhiên nhưng bạn sẽ cần nỗ lực hơn khi vào tiểu học.",
        "healthDelta": 5,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 0
      }
    ]
  },
  {
    "id": "ch_15_bicycle",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Chiếc Xe Đạp Ba Bánh",
    "descriptionVi": "Món quà khích lệ bạn chuẩn bị bước vào ngưỡng cửa trường học.",
    "category": "health",
    "choices": [
      {
        "id": "ch_15_a",
        "textVi": "Đạp xe vòng quanh ngõ xóm cùng lũ trẻ",
        "outcomeTextVi": "Bạn hoạt bát, chân tay rắn rỏi và rất thích khám phá thế giới.",
        "healthDelta": 15,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 15
      },
      {
        "id": "ch_15_b",
        "textVi": "Cùng cha tháo lắp lau chùi xích xe",
        "outcomeTextVi": "Niềm say mê kỹ thuật cơ khí nảy nở từ những chiếc ốc vít nhỏ.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ch_16_grandparents_story",
    "stageKey": "childhood",
    "age": 4,
    "titleVi": "Hơi Ấm Của Bà",
    "descriptionVi": "Trời mưa gió, bạn nằm trọn trong lòng bà nghe chuyện thời chiến gian nan.",
    "category": "family",
    "choices": [
      {
        "id": "ch_16_a",
        "textVi": "Hỏi han ngây thơ và đấm lưng cho bà",
        "outcomeTextVi": "Bà xoa đầu bạn mỉm cười mãn nguyện, phúc đức tổ tiên che chở bạn.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25
      },
      {
        "id": "ch_16_b",
        "textVi": "Ngủ thiếp đi trong tiếng ru êm đềm",
        "outcomeTextVi": "Giấc ngủ ngon lành nuôi dưỡng một tâm hồn bình yên.",
        "healthDelta": 10,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ch_17_lost_in_market",
    "stageKey": "childhood",
    "age": 4,
    "titleVi": "Lạc Giữa Chợ Đông",
    "descriptionVi": "Mải nhìn quầy đồ chơi rực rỡ, bạn tuột tay mẹ giữa phiên chợ tết đông đúc.",
    "category": "crisis",
    "choices": [
      {
        "id": "ch_17_a",
        "textVi": "Đứng yên tại chỗ và nhờ cô bán hàng gọi loa tìm mẹ",
        "outcomeTextVi": "Mẹ hớt hải chạy lại ôm chặt lấy bạn khóc nức nở. Bài học bình tĩnh quý giá.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      },
      {
        "id": "ch_17_b",
        "textVi": "Khóc toáng lên giữa chợ",
        "outcomeTextVi": "Bác bảo vệ dẫn bạn về trạm quản lý chợ trao trả cho mẹ an toàn.",
        "healthDelta": -5,
        "happinessDelta": -5,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ch_18_piggy_bank",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Chú Heo Đất Tiết Kiệm",
    "descriptionVi": "Được tiền mừng tuổi đầu năm, mẹ trao cho bạn một chú heo đất gốm đỏ.",
    "category": "career",
    "choices": [
      {
        "id": "ch_18_a",
        "textVi": "Cẩn thận bỏ từng đồng tiền xu và tiền giấy vào heo",
        "outcomeTextVi": "Khái niệm tích lũy tài chính và kiên nhẫn hình thành từ rất sớm.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 20,
        "intellectDelta": 15,
        "relationsDelta": 5
      },
      {
        "id": "ch_18_b",
        "textVi": "Đòi đập heo ngay để mua que kem và kẹo mút",
        "outcomeTextVi": "Niềm vui trước mắt nhưng bạn chưa học được bài học quản lý tiền bạc.",
        "healthDelta": -5,
        "happinessDelta": 15,
        "wealthDelta": -10,
        "intellectDelta": 0,
        "relationsDelta": 0
      }
    ]
  },
  {
    "id": "ch_19_music_class",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Giai Điệu Đầu Tiên",
    "descriptionVi": "Lớp mẫu giáo có cây đàn organ, cô giáo gõ từng phím thánh thót.",
    "category": "education",
    "choices": [
      {
        "id": "ch_19_a",
        "textVi": "Chăm chú ghi nhớ và gõ lại đúng nốt Đồ Rê Mi",
        "outcomeTextVi": "Đôi tai nhạy cảm âm nhạc của bạn khiến thầy cô bất ngờ.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 10
      },
      {
        "id": "ch_19_b",
        "textVi": "Hòa giọng hát vang rộn rã cùng cả lớp",
        "outcomeTextVi": "Bạn vui tươi, cởi mở và chan hòa với tập thể.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "ch_20_helping_grandma",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Nhặt Rau Cùng Bà",
    "descriptionVi": "Buổi chiều mùa thu, bạn ngồi xỏm nhặt từng cọng rau muống xanh non phụ bà.",
    "category": "family",
    "choices": [
      {
        "id": "ch_20_a",
        "textVi": "Kiên trì nhặt sạch từng cọng không bỏ sót lá úa",
        "outcomeTextVi": "Bà khen bạn khéo tay, tính tỉ mỉ hình thành theo năm tháng.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20
      },
      {
        "id": "ch_20_b",
        "textVi": "Nhặt được vài cọng rồi mải đuổi theo chú bướm vàng",
        "outcomeTextVi": "Bà cười hiền từ nhìn sự ngây thơ tinh nghịch của bạn.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ch_21_stormy_night",
    "stageKey": "childhood",
    "age": 3,
    "titleVi": "Đêm Bão Mất Điện",
    "descriptionVi": "Cơn bão ập tới làm đổ cây và mất điện toàn khu phố. Sấm chớp đùng đoàng.",
    "category": "crisis",
    "choices": [
      {
        "id": "ch_21_a",
        "textVi": "Nắm chặt tay cha nghe cha giải thích về sấm chớp tự nhiên",
        "outcomeTextVi": "Nỗi sợ tan biến, biến thành sự tò mò khoa học về thế giới tự nhiên.",
        "healthDelta": 0,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      },
      {
        "id": "ch_21_b",
        "textVi": "Rúc vào lòng mẹ đắp chăn kín mít",
        "outcomeTextVi": "Vòng tay mẹ luôn là bến đỗ an toàn nhất của cuộc đời.",
        "healthDelta": 5,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 0,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "ch_22_church_bell",
    "stageKey": "childhood",
    "age": 4,
    "titleVi": "Tiếng Chuông Nhà Thờ",
    "descriptionVi": "Mỗi ban chiều, tiếng chuông giáo đường ngân vang báo giờ kinh nguyện.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "ch_22_a",
        "textVi": "Làm dấu Thánh Giá sốt sắng theo cha mẹ",
        "outcomeTextVi": "Bạn nhận biết sự hiện diện yêu thương của Chúa trong cuộc sống hằng ngày.",
        "healthDelta": 5,
        "happinessDelta": 15,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 15
      },
      {
        "id": "ch_22_b",
        "textVi": "Cùng lũ trẻ trong xóm ngóng đàn bồ câu bay lượn quanh tháp chuông",
        "outcomeTextVi": "Hình ảnh thanh bình in đậm sâu vào tiềm thức tuổi thơ.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ch_23_dentist_visit",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Khám Răng Lần Đầu",
    "descriptionVi": "Một chiếc răng bị sâu nhẹ, mẹ dắt bạn đến phòng khám nha khoa.",
    "category": "health",
    "choices": [
      {
        "id": "ch_23_a",
        "textVi": "Ngoan ngoãn há miệng theo hướng dẫn của bác sĩ",
        "outcomeTextVi": "Răng được hàn kịp thời, bạn được tặng một chiếc bàn chải hình gấu xinh xắn.",
        "healthDelta": 15,
        "happinessDelta": 10,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 10
      },
      {
        "id": "ch_23_b",
        "textVi": "Vùng vằng cắn chặt răng vì sợ tiếng máy mài",
        "outcomeTextVi": "Mẹ phải kiên nhẫn dỗ dành cả tiếng đồng hồ mới hoàn tất.",
        "healthDelta": 5,
        "happinessDelta": -5,
        "wealthDelta": -10,
        "intellectDelta": 0,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ch_24_little_gardener",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Người Làm Vườn Nhỏ Tuổi",
    "descriptionVi": "Cha cho bạn một chậu đất nhỏ và vài hạt mầm đậu xanh.",
    "category": "education",
    "choices": [
      {
        "id": "ch_24_a",
        "textVi": "Hằng ngày đều đặn tưới nước đón mầm xanh nhú lên",
        "outcomeTextVi": "Chứng kiến sự sống sinh sôi, bạn học được lòng nhẫn nại và quý trọng tự nhiên.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 10
      },
      {
        "id": "ch_24_b",
        "textVi": "Bới tung đất ra xem hạt nảy mầm chưa",
        "outcomeTextVi": "Mầm cây hỏng nhưng bạn hiểu rằng mọi thứ cần thời gian để lớn lên.",
        "healthDelta": 0,
        "happinessDelta": 5,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 5
      }
    ]
  },
  {
    "id": "ch_25_bedtime_gratitude",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Lời Cảm Ơn Trước Khi Ngủ",
    "descriptionVi": "Kết thúc một ngày vui chơi, mẹ hỏi: \"Hôm nay con thấy vui nhất điều gì?\"",
    "category": "family",
    "choices": [
      {
        "id": "ch_25_a",
        "textVi": "Kể lại chuyện chia sẻ đồ chơi và ôm hôn cảm ơn cha mẹ",
        "outcomeTextVi": "Trái tim ấm áp biết ơn sẽ là hành trang tuyệt vời theo bạn suốt đời.",
        "healthDelta": 5,
        "happinessDelta": 20,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 20,
        "addVirtue": "Lòng biết ơn chân thành nuôi dưỡng tâm hồn cao đẹp"
      },
      {
        "id": "ch_25_b",
        "textVi": "Ngáp dài rồi chúc cả nhà ngủ ngon",
        "outcomeTextVi": "Một ngày khép lại bình yên và sẵn sàng cho những chặng đường mới.",
        "healthDelta": 10,
        "happinessDelta": 10,
        "wealthDelta": 0,
        "intellectDelta": 5,
        "relationsDelta": 10
      }
    ]
  },
  {
    "id": "ch_26_first_backpack",
    "stageKey": "childhood",
    "age": 5,
    "titleVi": "Chiếc Cặp Sách Đầu Tiên",
    "descriptionVi": "Ngày mua sắm chuẩn bị vào lớp 1, chiếc cặp sách mới tinh thơm mùi vải.",
    "category": "education",
    "choices": [
      {
        "id": "ch_26_a",
        "textVi": "Tự tay sắp xếp từng quyển vở, chiếc bút chì nắp nhọn",
        "outcomeTextVi": "Tác phong ngăn nắp, chỉn chu hứa hẹn những năm tháng học trò rạng rỡ.",
        "healthDelta": 0,
        "happinessDelta": 20,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 10
      },
      {
        "id": "ch_26_b",
        "textVi": "Đeo cặp chạy nhảy khắp nhà khoe với ông bà chòm xóm",
        "outcomeTextVi": "Tinh thần hân hoan đón chào hành trình tri thức mới.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": -5,
        "intellectDelta": 5,
        "relationsDelta": 15
      }
    ]
  }
];
